var _style, _circle, _g, _path, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebdesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{font-family:'Bauhaus93';}\r\n\t.st2{font-size:27.8951px;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1,
    cy: 60,
    r: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.8,75.5L106.8,75.5L82.1,91.7c0.2-0.1,1.5,1.4,2.5,2.8s1.9,3.2,1.7,3.3l24.1-17.1l0,0 c1-0.8,1.1-2.5,0.1-3.9C109.5,75.4,107.9,74.8,106.8,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.7,92.8C77,94,76.3,92.9,71.9,96c-4.4,3-4.2,11.6-4.2,11.6s1.7-1.6,7.2-2.2c5.5-0.6,9.5-5.7,9.5-5.7 c0.4-0.3-0.4-2-1.7-3.9C81.4,93.8,80.1,92.5,79.7,92.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.8,77.5c0-0.2,0-0.3,0-0.5V45c0-2.4-2-4.4-4.4-4.4H37c-2.4,0-4.4,2-4.4,4.4V77c0,0.2,0,0.3,0,0.5h-6.1v1.8 c0,1.4,1,2.5,2.1,2.5h63.1c1.2,0,2.1-1.1,2.1-2.5v-1.8H87.8z M85.1,75.7h-50V44.3h50V75.7z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 43.7598 70.832)",
    className: "st0 st1 st2"
  }, "&lt; &gt;")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdesign);
export default __webpack_public_path__ + "static/media/webdesign.13a7e050f941f5209d590297047395a8.svg";
export { ForwardRef as ReactComponent };